import client from '../client';
import endpoints from '../endpoints';

/** GET /api/users/me */
export const getProfile = () => client.get(endpoints.users.me).then((r) => r.data);

/** PUT /api/users/me */
export const updateProfile = (data) => client.put(endpoints.users.me, data).then((r) => r.data);

/** PUT /api/users/me/password */
export const changePassword = (data) => client.put(endpoints.users.password, data).then((r) => r.data);

/** DELETE /api/users/me */
export const deleteAccount = () => client.delete(endpoints.users.me).then((r) => r.data);

/** GET /api/users/me/reviews */
export const getMyReviews = (params) => client.get(endpoints.users.reviews, { params }).then((r) => r.data);

/** GET /api/users/me/waitlist */
export const getMyWaitlist = () => client.get(endpoints.users.waitlist).then((r) => r.data);
